import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "it", setLang: () => {}, t: (it) => it });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("adriatica-lang") || "it";
    } catch {
      return "it";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("adriatica-lang", l);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (it, en) => (lang === "en" ? en : it);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useLang();
  return (
    <span
      data-testid="lang-switcher"
      className={`inline-flex items-center rounded-full border border-[#D4AF37]/40 overflow-hidden ${compact ? "" : ""}`}
    >
      {["it", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-switch-${l}`}
          onClick={() => setLang(l)}
          className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
            lang === l ? "bg-gradient-to-r from-[#D4AF37] to-[#F3E08B] text-[#070D18]" : "text-slate-400 hover:text-[#F3E08B]"
          }`}
        >
          {l}
        </button>
      ))}
    </span>
  );
};
